import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
const _excluded = ["rasterData"];
import { getDefaultDomain } from '@antv/l7-utils';
import RasterLayer from "../../raster";
import Tile from "./Tile";
const DEFAULT_COLOR_TEXTURE_OPTION = {
  positions: [0, 1],
  colors: ['#000', '#fff']
};
export default class RasterTile extends Tile {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "colorTexture", void 0);
  }
  initTileLayer() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const attributes = _this.parent.getLayerAttributeConfig();
      const layerOptions = _this.getLayerOptions();
      const sourceOptions = _this.getSourceOption();
      const {
        rampColors,
        domain
      } = _this.getLayerOptions();
      _this.colorTexture = _this.parent.textureService.getColorTexture(rampColors, domain);
      const layer = new RasterLayer(_objectSpread(_objectSpread({}, layerOptions), {}, {
        colorTexture: _this.colorTexture
      })).source(sourceOptions.data, sourceOptions.options);

      // 初始化数据映射
      // tslint:disable-next-line: no-unused-expression
      attributes && Object.keys(attributes).forEach(type => {
        var _attributes$attr, _attributes$attr2;
        const attr = type;
        // @ts-ignore
        layer[attr]((_attributes$attr = attributes[attr]) === null || _attributes$attr === void 0 ? void 0 : _attributes$attr.field, (_attributes$attr2 = attributes[attr]) === null || _attributes$attr2 === void 0 ? void 0 : _attributes$attr2.values);
      });
      yield _this.addLayer(layer);
      _this.isLoaded = true;
    })();
  }
  getSourceOption() {
    const rawSource = this.parent.getSource();
    const _this$sourceTile$data = this.sourceTile.data.data,
      {
        rasterData
      } = _this$sourceTile$data,
      res = _objectWithoutProperties(_this$sourceTile$data, _excluded);
    return {
      data: rasterData,
      options: {
        parser: _objectSpread({
          type: 'raster',
          extent: this.sourceTile.bounds
        }, res),
        transforms: rawSource.transforms
      }
    };
  }

  /**
   * 用于 style 更新 colorTexture 的优化
   * @param arg
   */
  styleUpdate(...arg) {
    const {
      rampColors = DEFAULT_COLOR_TEXTURE_OPTION,
      domain
    } = arg;
    this.colorTexture = this.parent.textureService.getColorTexture(rampColors, domain || getDefaultDomain(rampColors));
    this.layers.forEach(layer => layer.style({
      colorTexture: this.colorTexture
    }));
  }
  destroy() {
    this.layers.forEach(layer => layer.destroy());
  }
}